import PackageOverview from "./PackageOverview";
import React, { useEffect, useState } from "react";
import routes from "../../constants/Routes";
import CONSTANT from "../../constants/Constant";
import useRedirect from "../../hooks/useRedirect";
import DirectToConsumerService from "../../services/DirectToConsumerService";
import PackageData from "../../models/PackageData";
import GLOBAL from "../../global";

const Packages = (props) => {
    const [isLoadingNotification, setIsLoadingNotification] = useState(true);
    const [isError, setIsError] = useState(false);
    const [packages, setPackages] = useState([]);


    const bgClass = props?.bgClass || 'bg-color-light-gray-1';
    const tenant = GLOBAL.TENANT;

    const { redirect } = useRedirect();

    useEffect(() => {
        handleGetPackages();
    }, []);

    const handleGetPackages = async () => {
        let queryString = `?${CONSTANT.QUERY_PARAM.TENANT}=${tenant}`;
        let tempPackagesData = await DirectToConsumerService.getAllPackages(queryString);
        if(tempPackagesData.success) {
            let tempPackages = tempPackagesData.data.map((packageData) => {
                return new PackageData(packageData);
            });
            setPackages(tempPackages);
        } else {
            setIsError(true);
        }
        setIsLoadingNotification(false);
    }

    const handleOnClickGetStarted = (packageData) => {
        redirect(`${routes.packageDetails}?${CONSTANT.QUERY_PARAM.PACKAGE_ID}=${packageData?.gId || 0}`);
    }

    return (
        <div>
            {
                (isLoadingNotification || isError)
                    ?
                    (
                        <div className="position-center">
                            {isLoadingNotification && <i className="fa fa-spinner fa-spin font-size-4-rem"></i>}
                            {isError && <div className="font-size-2-rem">Internal Server Error</div>}
                        </div>
                    )
                    : (

                        <div
                            className="packages-list d-flex flex-wrap align-items-stretch justify-content-center margin-1-rem"
                        >
                            {packages.map((packageData, index) => {
                                return (
                                    <PackageOverview
                                        key={packageData?.gId || index}
                                        title={packageData?.title || ''}
                                        iconSrc={packageData?.imageUrl || ''}
                                        price={packageData?.price || 0}
                                        basePrice={packageData?.basePrice || 0}
                                        shortDescription={packageData?.shortDescription || ''}
                                        onClickGetStarted={() => handleOnClickGetStarted(packageData)}
                                        btnText="Show Details"
                                    />
                                )
                            })}
                        </div>
                    )
            }
        </div>
    )
}

export default Packages
